import { render, staticRenderFns } from "./ProjectBreadcrumb.vue?vue&type=template&id=7640a6f6&"
import script from "./ProjectBreadcrumb.vue?vue&type=script&lang=ts&"
export * from "./ProjectBreadcrumb.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectBreadcrumb.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
installComponents(component, {VBreadcrumbs})
